// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9b904153","453":"d50cc986","455":"1734b6e4"}[chunkId] + ".chunk.js";
};